export enum MaritalStatus {
  SINGLE = 'Single',
  MARRIED = 'Married'
}
